<template>
  <div>
    <table-component
      :model="model"
    />
  </div>
</template>

<script>
import TableComponent from '@/dc-it/components/TableComponent.vue'
import Plan from '@/dc-it/models/Plan'

export default {
  name: 'UsersView',
  components: { TableComponent },
  data() {
    return {
      model: Plan,
    }
  },
}
</script>

<style scoped>

</style>
